import type { ApiNodeDataCollectDocument, DocumentRequestConfig } from '@onefootprint/request-types/dashboard';
import type { TFunction } from 'i18next';

export const getCollectDocumentSubtitle = (
  data: ApiNodeDataCollectDocument,
  t: TFunction<'playbook-builder'>,
): string => {
  const documentTitle: Record<Exclude<DocumentRequestConfig['kind'], 'custom'>, string> = {
    proof_of_address: t($ => $.collectDocument.proofOfAddress),
    proof_of_ssn: t($ => $.collectDocument.proofOfSsn),
    identity: t($ => $.collectDocument.identityDocument),
    selfie: t($ => $.node.selfie.uppercase),
  };

  const getTitle = (config: DocumentRequestConfig) => {
    if (config.kind === 'custom') return config.data.name;
    return documentTitle[config.kind];
  };

  return data.documents.map(getTitle).join(', ');
};
